import CryptoJS from 'crypto-js'
import { deflate, inflate } from 'pako'
import { sm4 } from 'sm-crypto'

/**
 * SM4加密
 * @param data 要加密的数据
 * @param key 加密秘钥
 * @returns  返回加密字符串
 */
export function sm4Encrypt(data, key) {
    try {
        const str = JSON.stringify(data)
        console.log(sm4.encrypt(str, key))
        return sm4.encrypt(str, key)
    }
    catch (e) {
        throw new Error(`Failed to encrypt data: ${e.message}`)
    }
}

/**
 * SM4解密
 * @param data 要解密的数据
 * @param key 解密秘钥
 * @returns  返回解密后的字符串或对象
 */
export function sm4Decrypt(data, key) {
    try {
        const content = sm4.decrypt(data, key)
        return JSON.parse(content)
    }
    catch {
        const content = sm4.decrypt(data, key)
        return content
    }
}

/**
 * 解压加密字符串
 * @param str 加密字符串
 * @param key 解密秘钥
 * @returns
 */
import { Base64 } from 'js-base64'
export function unzipString(str, key) {
    try {
        const zippedString = CryptoJS.enc.Base64.parse(str).toString(CryptoJS.enc.Utf8)
        const binaryString = atob(zippedString)
        const uint8Array = new Uint8Array(binaryString.length)
        for (let i = 0; i < binaryString.length; i++) {
            uint8Array[i] = binaryString.charCodeAt(i)
        }
        const unzippedArray = inflate(uint8Array)
        const unzippedString = new TextDecoder().decode(unzippedArray)
        return sm4Decrypt(unzippedString, Base64.decode(key))
    }
    catch (e) {
        throw new Error(`Failed to unzip and decrypt string: ${e.message}`)
    }
}

/**
 * 压缩字符串
 * @param str 要压缩的字符串
 */
export function zipString(str) {
    try {
        const encoder = new TextEncoder()
        const uint8Array = encoder.encode(str)
        const zippedArray = deflate(uint8Array)
        return btoa(Array.from(zippedArray).map(byte => String.fromCharCode(byte)).join(''))
    }
    catch (e) {
        throw new Error(`Failed to zip string: ${e.message}`)
    }
}

/**
 * stringToHmacSHA256 加密
 * @param str 待加密的字符串
 * @param key 密钥
 */
export function stringToHmacSHA256(str, key) {
    return CryptoJS.HmacSHA256(str, CryptoJS.enc.Utf8.parse(key)).toString(CryptoJS.enc.Hex)
}

/**
 * 对象排序
 * @param obj 对象
 */
export function sortObjectByKeys(obj) {
    if (Array.isArray(obj) || typeof obj !== 'object' || obj === null)
        return obj
    const sortedObj = {}
    const validEntries = Object.entries(obj)
        .filter(([key, value]) => {
            if (key === 'appId')
                return true
            return value !== '' && value !== null && value !== undefined
                && !(Array.isArray(value) && value.length === 0)
        })
        .sort(([a], [b]) => {
            // 按照 ASCII 码排序
            for (let i = 0; i < Math.min(a.length, b.length); i++) {
                const diff = a.charCodeAt(i) - b.charCodeAt(i)
                if (diff !== 0)
                    return diff
            }
            return a.length - b.length
        })
    for (const [key, value] of validEntries) {
        sortedObj[key] = value
    }

    return sortedObj
}

/**
 * 生成SM4密钥
 * @returns 16字节的SM4密钥
 */
// export function generateSM4Key() {
//     const key = new Uint8Array(16)
//     if (typeof window !== 'undefined' && window.crypto) {
//         window.crypto.getRandomValues(key)
//     }
//     else if (typeof require !== 'undefined') {
//         // eslint-disable-next-line ts/no-require-imports
//         const crypto = require('node:crypto')
//         const buffer = crypto.randomBytes(16)
//         return buffer.toString('hex')
//     }
//     else {
//         for (let i = 0; i < 16; i++) {
//             key[i] = Math.floor(Math.random() * 256)
//         }
//     }

//     return Array.from(key)
//         .map(byte => byte.toString(16).padStart(2, '0'))
//         .join('')
// }
export function generateSM4Key() {
    // 创建一个长度为16字节的Uint8Array，用于存储密钥
    const key = new Uint8Array(16)
    // 使用crypto API生成安全的随机字节填充到key中
    window.crypto.getRandomValues(key)
    // 将Uint8Array转换为十六进制字符串，方便显示或传输
    const keyHexString = Array.from(key)
        .map(byte => byte.toString(16).padStart(2, '0'))
        .join('')
    return keyHexString
}
